import { Header } from '@business/workflows/ComponentUI/Header/Header';
import { Sidebar } from '@business/workflows/ComponentUI/Sidebar';
import { MediaUploadPersister } from '@business/workflows/ComponentViews/Photos';
import { useFirebaseTokenRegister } from '@hooks/useFirebaseTokenRegister';
import { getFirstLogin } from '@ports/common/authStateSlice';
import { routePaths } from '@utils/constants/routePaths';
import { generateToken } from '@pushNotifications/firebase';
import { FC, ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';

interface BaseAppLayoutProps {
  children?: ReactNode;
}

export const BaseAppLayout: FC<BaseAppLayoutProps> = ({ children }) => {
  const isFirstLogin = useSelector(getFirstLogin);
  const location = window.location.pathname;
  const { userDeviceHandler } = useFirebaseTokenRegister();

  useEffect(() => {
    generateToken()
      .then(token => {
        if (token) {
          userDeviceHandler(token);
        }
      })
      .catch(err => {
        console.error('Error generating Firebase token:', err);
      });
  }, []);

  const isFamilyTree =
    location === routePaths.FamilyTree ||
    location === routePaths.SharedFamilyTree;

  return (
    <div className="h-screen flex overflow-hidden bg-gray-50 relative">
      {!isFirstLogin && <Sidebar />}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main
          className={`flex-1 ${
            isFamilyTree ? 'overflow-hidden' : 'overflow-y-auto bg-white'
          }`}>
          <div
            className={
              isFamilyTree
                ? 'h-full overflow-hidden'
                : `mx-auto px-4 sm:px-6 lg:px-8 py-4 2xl:py-6 ${isFirstLogin ? 'max-w-7xl' : 'max-w-full'}`
            }>
            {children}
          </div>
          {!isFirstLogin && <MediaUploadPersister />}
        </main>
      </div>
    </div>
  );
};
